import m from "mithril";
import {CardieWidget, defineWidget} from "@nebularstreams/libmui";

const

	// widget: Video Player
	RePlayer = defineWidget(
		({attrs}) => m(CardieWidget, {
			title: "Replayer" + (attrs.title ? " - " + attrs.title : ""),
			element: "div",
			class: "replayer",
			expandedView: () => [
				m("iframe", {
					src: `https://ffmpeg-service.pages.nanocosmos.de/live-replay/main/replayer/?streamname=${attrs.streamname}&session=${attrs.session}`
				})
			]
		})
	);

export {RePlayer};
